<script setup>
import { useMobileDetection } from '@pfsc/core/ui-services/use-mobile-detection';
import { ref, watch } from 'vue';

const unassignedLearnerCheckboxRef = ref(null);

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['update:model-value']);

const { isMobile } = useMobileDetection();

/**
 * Add or remove selected class.
 * @param {boolean} isAdd Whether we should add or remove selected row class.
 */
function addOrRemoveSelectedClass(isAdd) {
  const checkbox = unassignedLearnerCheckboxRef.value;
  const tr = checkbox.closest('tr');
  if (tr && isAdd) {
    tr.classList.add('row-selected');
    return;
  }
  tr.classList.remove('row-selected');
}

/**
 * Handle checkbox checked.
 * @param {boolean} isChecked Is checked.
 */
function onCheckboxCheck(isChecked) {
  emits('update:model-value', isChecked);
}

watch(() => props.modelValue, () => {
  addOrRemoveSelectedClass(props.modelValue);
});

</script>

<template>
  <div ref="unassignedLearnerCheckboxRef">
    <v-checkbox-btn
      :disabled="disabled"
      :density="isMobile ? 'compact' : 'default'"
      :model-value="modelValue"
      @update:model-value="onCheckboxCheck($event)"
    />
  </div>
</template>
